export const FILTER_ITEMS = {
  BOT: 'botIds',
  BOTS: 'logicalBotIds',
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
  REQUEST_OUTCOME: 'requestOutcomes',
  ASSISTANCE_RESOLUTIONS: 'assistanceResolutions',
  CHANNELS: 'channels',
  MARKETS: 'markets',
  GRANULARITY: 'granularity',
  ANSWER_ID: 'answerId'
}

export const GRANULARITY_REQUEST = 'request'
export const GRANULARITY_CONTACT = 'contact'
export const GRANULARITY_OPTIONS = [
  { id: GRANULARITY_REQUEST, name: 'Request', icon: 'request-icon' },
  { id: GRANULARITY_CONTACT, name: 'Contact', icon: 'contact-icon' }
]

export const PERIODS = Object.freeze({
  year: {
    name: 'year',
    unit: 'year',
    amount: 1,
    milliseconds: 31557600000,
    format: 'yyyy'
  },
  sixMonths: {
    name: 'sixMonths',
    unit: 'month',
    amount: 6,
    milliseconds: 15778800000,
    format: 'MMM yyyy'
  },
  threeMonths: {
    name: 'threeMonths',
    unit: 'month',
    amount: 3,
    milliseconds: 7889400000,
    format: 'MMM yyyy'
  },
  month: {
    name: 'month',
    unit: 'month',
    amount: 1,
    milliseconds: 2629800000,
    format: 'MMM yyyy'
  },
  twoWeeks: {
    name: 'twoWeeks',
    unit: 'week',
    amount: 2,
    milliseconds: 1209600034,
    format: 'DD MMM'
  },
  week: {
    name: 'week',
    unit: 'week',
    amount: 1,
    milliseconds: 604800017,
    format: 'DD MMM'
  },
  threeDays: {
    name: 'threeDays',
    unit: 'day',
    amount: 3,
    milliseconds: 259200000,
    format: 'DD MMM'
  },
  day: {
    name: 'day',
    unit: 'day',
    amount: 1,
    milliseconds: 86400000,
    format: 'DD MMM'
  },
  twelveHours: {
    name: 'twelveHours',
    unit: 'hour',
    amount: 12,
    milliseconds: 43200000,
    format: 'DD MMM HH:mm'
  },
  sixHours: {
    name: 'sixHours',
    unit: 'hour',
    amount: 6,
    milliseconds: 21600000,
    format: 'DD MMM HH:mm'
  },
  threeHours: {
    name: 'threeHours',
    unit: 'hour',
    amount: 3,
    milliseconds: 10800000,
    format: 'DD MMM HH:mm'
  },
  hour: {
    name: 'hour',
    unit: 'hour',
    amount: 1,
    milliseconds: 3600000,
    format: 'DD MMM HH:mm'
  },
  thirtyMinutes: {
    name: 'thirtyMinutes',
    unit: 'minute',
    amount: 30,
    milliseconds: 1800000,
    format: 'DD MMM HH:mm'
  },
  fifteenMinutes: {
    name: 'fifteenMinutes',
    unit: 'minute',
    amount: 15,
    milliseconds: 900000,
    format: 'DD MMM HH:mm'
  },
  tenMinutes: {
    name: 'tenMinutes',
    unit: 'minute',
    amount: 10,
    milliseconds: 600000,
    format: 'DD MMM HH:mm'
  }
})

export const OUTCOME_MAPPING = Object.freeze({
  automationRate: {
    CUSTOMER_ANSWERED_YES: 'fullyAutomated',
    REQUEST_STARTED: 'fullyAutomated',
    SMALL_TALK: 'fullyAutomated',
    CUSTOMER_STARTED_TO_WRITE: 'fullyAutomated',
    CUSTOMER_ANSWERED_PARTIALLY: 'partiallyAutomated',
    BOT_DID_NOT_FIND_INTENT: 'notAutomated',
    CUSTOMER_ANSWERED_NO: 'wrongAnswer',
    AGENT_REQUESTED: 'requestedOperator',
    DIRECT_CALL_FOR_HUMAN_AGENT: 'requestedOperator',
    AGENT_OFFLINE: 'agentOffline',
    CONVERSATION_TIMEOUT: 'conversationTimeout'
  },
  assistanceType: {
    AGENT_OFFLINE: 'agentOffline',
    CONVERSATION_TIMEOUT: 'conversationTimeout',
    AGENT_REQUESTED: 'servedByOperator',
    CUSTOMER_ANSWERED_YES: 'servedByBot',
    REQUEST_STARTED: 'servedByBot',
    SMALL_TALK: 'servedByBot',
    CUSTOMER_STARTED_TO_WRITE: 'servedByBot',
    CUSTOMER_ANSWERED_PARTIALLY: 'servedByBot',
    BOT_DID_NOT_FIND_INTENT: 'servedByBot',
    CUSTOMER_ANSWERED_NO: 'servedByBot',
    DIRECT_CALL_FOR_HUMAN_AGENT: 'servedByBot'
  },
  intentUsages: {
    CUSTOMER_ANSWERED_YES: 'fullyAutomated',
    REQUEST_STARTED: 'fullyAutomated',
    SMALL_TALK: 'fullyAutomated',
    CUSTOMER_STARTED_TO_WRITE: 'fullyAutomated',
    CUSTOMER_ANSWERED_PARTIALLY: 'partiallyAutomated',
    BOT_DID_NOT_FIND_INTENT: 'fullyAutomated',
    CUSTOMER_ANSWERED_NO: 'wrongAnswer',
    AGENT_REQUESTED: 'requestedOperator',
    DIRECT_CALL_FOR_HUMAN_AGENT: 'fullyAutomated'
  },
  intentUsagesEmail: {
    REQUEST_STARTED: 'fullyAutomated',
    SMALL_TALK: 'fullyAutomated',
    CUSTOMER_STARTED_TO_WRITE: 'fullyAutomated',
    BOT_DID_NOT_FIND_INTENT: 'notAutomated',
    AGENT_REQUESTED: 'requestedOperator',
    DIRECT_CALL_FOR_HUMAN_AGENT: 'requestedOperator'
  }
})

export const LEGEND_MAPPING = Object.freeze({
  requestOutcomes: {
    fullyAutomated: ['CUSTOMER_ANSWERED_YES', 'REQUEST_STARTED', 'SMALL_TALK', 'CUSTOMER_STARTED_TO_WRITE'],
    partiallyAutomated: ['CUSTOMER_ANSWERED_PARTIALLY'],
    notAutomated: ['BOT_DID_NOT_FIND_INTENT'],
    wrongAnswer: ['CUSTOMER_ANSWERED_NO'],
    requestedOperator: ['AGENT_REQUESTED', 'DIRECT_CALL_FOR_HUMAN_AGENT']
  },
  assistanceResolutions: {
    servedByBot: ['CUSTOMER_ANSWERED_YES', 'REQUEST_STARTED', 'SMALL_TALK', 'CUSTOMER_STARTED_TO_WRITE', 'CUSTOMER_ANSWERED_PARTIALLY', 'BOT_DID_NOT_FIND_INTENT', 'CUSTOMER_ANSWERED_NO', 'DIRECT_CALL_FOR_HUMAN_AGENT'],
    servedByOperator: ['AGENT_REQUESTED', 'DIRECT_CALL_FOR_HUMAN_AGENT'],
    agentOffline: ['AGENT_OFFLINE'],
    conversationTimeout: ['CONVERSATION_TIMEOUT']
  }
})

export const ASSISTANCE_TYPE_LEGEND_ORDER = Object.freeze({
  servedByBot: 0, servedByOperator: 1, agentOffline: 2, conversationTimeout: 3
})

export const AUTOMATION_RATE_LEGEND_ORDER = Object.freeze({
  fullyAutomated: 0,
  partiallyAutomated: 1,
  conversationTimeout: 2,
  notAutomated: 3,
  requestedOperator: 4,
  wrongAnswer: 5,
  agentOffline: 6
})

export const IGNORED_OUTCOMES = Object.freeze([
  'AGENT_OFFLINE', 'CONVERSATION_TIMEOUT'
])
